import { useTranslation } from 'react-i18next';

import aleaSidebarLogo from "../../../assets/img/png/logo/alea-sidebar-logo.png";
import minimizedAleaLogo from "../../../assets/img/svg/sidebar/minimized-logo.svg";

import { useAppSelector } from '../../../hook/useAppSelector';
import { DateFilter } from './DatePicker/DatePicker';
import { useAllFilters } from '../../../hook/useAllFilters';
import DesktopFilters from './Filters/DesktopFilters';
import SearchBar from '../Content/HealthMonitor/SearchBar/SearchBar';
import { useHeaderConfig } from '../../../hook/useHeaderConfig';
import { menus } from '../../../util/route/menus';

interface Props {
  title: string;
  icon: string;
}

const DesktopHeader: React.FC<Props> = ({ title, icon }) => {
  const isSidebarMinimized = useAppSelector((state) => state.configSlice.isSidebarMinimized);
  const filterType = useAppSelector((state) => state.globalFilters.filterType);
  const headerConfig = useHeaderConfig(menus);

  const { t } = useTranslation();
  const { handleApplyAllFilters } = useAllFilters();

  return (
    <div className={`header ${isSidebarMinimized ? 'minimized' : ''}`}>
      <div className="logo">
        <img src={isSidebarMinimized ? minimizedAleaLogo : aleaSidebarLogo} alt="aleaSidebarLogo"></img>
      </div>
      <div className="content">
        {headerConfig.datePicker && <DateFilter onSearch={handleApplyAllFilters} />}
        {headerConfig.search && <SearchBar hasSearchColumnDropdownPicker={false} />}

        <span className="title page_title">
          <img src={icon} alt="hmTitlePulse"></img>
          {t(title)}
        </span>

        {filterType && <DesktopFilters></DesktopFilters>}
      </div>
    </div>
  );
};

export default DesktopHeader;
